const parseSseConversationResponse = (rawPayload) => {
  const fallbackResponse = {
    chunks: [],
    aiReply: '',
    id: null,
    type: 'done'
  };

  if (!rawPayload || typeof rawPayload !== 'string') {
    return fallbackResponse;
  }

  const trimmedPayload = rawPayload.trim();
  if (!trimmedPayload) {
    return fallbackResponse;
  }

  if (!trimmedPayload.includes('data:')) {
    try {
      const parsedJson = JSON.parse(trimmedPayload);
      if (Array.isArray(parsedJson?.chunks)) {
        return {
          chunks: parsedJson.chunks,
          aiReply: parsedJson.aiReply || parsedJson.chunks.join(''),
          id: parsedJson.id || parsedJson.messageId || null,
          type: parsedJson.type || 'done'
        };
      }

      return parsedJson;
    } catch (error) {
      return {
        ...fallbackResponse,
        aiReply: trimmedPayload,
        chunks: [trimmedPayload]
      };
    }
  }

  const lines = trimmedPayload
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.startsWith('data:'));

  let finalEvent = null;
  const chunks = [];

  lines.forEach((line) => {
    const eventText = line.slice('data:'.length).trim();
    if (!eventText) {
      return;
    }

    try {
      const parsedEvent = JSON.parse(eventText);

      if (parsedEvent?.type === 'done') {
        finalEvent = parsedEvent;
        return;
      }

      if (parsedEvent?.type === 'chunk' && typeof parsedEvent.text === 'string') {
        // Some backends send a literal "done" chunk before the final done event.
        if (parsedEvent.text.toLowerCase() !== 'done') {
          chunks.push(parsedEvent.text);
        }
      }
    } catch (error) {
      // Ignore malformed event lines and continue parsing the remaining stream.
    }
  });

  const aiReply = finalEvent?.aiReply || chunks.join('');

  return {
    chunks,
    aiReply,
    id: finalEvent?.id || null,
    type: finalEvent?.type || 'done',
    inputTokens: finalEvent?.inputTokens,
    outputTokens: finalEvent?.outputTokens,
    totalTokens: finalEvent?.totalTokens
  };
};

export default parseSseConversationResponse;